var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultsOnThereWaySymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "eyj91amp4a",
    d: "M0 0.9L61 0.9 61 66.9 0 66.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249 -423) translate(249 423)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "#DFDFDF",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 20) translate(0 .32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xxvs9jmutb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eyj91amp4a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    stroke: "#979797",
    d: "M30.385 61.712c-13.894 0-25.198-11.303-25.198-25.197 0-13.894 11.304-25.197 25.198-25.197S55.582 22.62 55.582 36.515c0 13.894-11.303 25.197-25.197 25.197m1.093-56.145h9.79V3.379H19.501v2.188h9.79v3.591C14.728 9.738 3 21.863 3 36.515 3 51.615 15.285 63.9 30.385 63.9c15.1 0 27.385-12.285 27.385-27.385 0-14.652-11.73-26.776-26.292-27.357V5.567z",
    mask: "url(#xxvs9jmutb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    stroke: "#979797",
    d: "M31.478 19.182L29.291 19.182 29.291 37.93 40.48 37.93 40.48 35.742 31.478 35.742z",
    transform: "translate(26 20)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsOnThereWaySymbol);
export default __webpack_public_path__ + "static/media/results-on-there-way-symbol.53fcd660.svg";
export { ForwardRef as ReactComponent };